import { ReduxState } from 'src/store/types';

export const voiceboxModeSelector = (state: ReduxState) => state.voicebox.mode;

export const voiceboxConversationIdSelector = (state: ReduxState) =>
  state.voicebox.conversationId;

export const voiceboxConversationSelector = (state: ReduxState) =>
  state.voicebox.conversationMessages;

export const isVoiceboxPendingSelector = (state: ReduxState) =>
  state.voicebox.pending;
